import { CREATEBOOK, GETBOOK, GETALLBOOK, DELETEBOOK, UPDATEBOOK } from "../constants/actionTypes";
import { CREATEREQUEST, GETREQUEST, DELETEREQUEST, UPDATEREQUEST } from "../constants/actionTypes";


export default (mybooks = [], action) =>{
    switch (action.type){
        case GETBOOK:
            return action.payload;
        case GETALLBOOK:
            return action.payload;
        case CREATEBOOK:
            return [... mybooks, action.payload];  
        case UPDATEBOOK:
            return mybooks.map((updatedBook) => updatedBook._id === action.data._id ? action.data : updatedBook);
        case DELETEBOOK:
            return mybooks.filter((mybooks) => mybooks._id !== action.id);
        case GETREQUEST:
            return action.payload;
        case CREATEREQUEST:
            return [... mybooks, action.payload];  
        case UPDATEREQUEST:
            return mybooks.map((updatedBook) => updatedBook._id === action.data._id ? action.data : updatedBook);
        case DELETEREQUEST:
            return mybooks.filter((mybooks) => mybooks._id !== action.id);
        default:
            return mybooks;      
    }
}